import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import { TValueProvider, TWorkflowDefinition } from '@commenda/types';
import { VariablesBindingForm } from '../forms/VariablesBindingForm';

export const VariablesBindingModal = ({
  isOpen,
  onClose,
  variableName,
  value,
  onSave,
  workflowDefinition,
  currentStepId,
}: {
  isOpen: boolean;
  onClose: () => void;
  variableName: string | null;
  value: TValueProvider | null;
  onSave: (variableName: string, value: TValueProvider) => void;
  workflowDefinition: TWorkflowDefinition;
  currentStepId: string;
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="flex flex-col overflow-hidden">
        <DialogHeader>
          <DialogTitle>
            {value ? 'Edit binding' : 'Bind value'} for &ldquo;{variableName}
            &rdquo;
          </DialogTitle>
        </DialogHeader>
        <div className="grow overflow-auto max-h-[80vh]">
          {variableName && (
            <VariablesBindingForm
              variableName={variableName}
              value={value}
              onSave={(v) => {
                onSave(variableName, v);
                onClose();
              }}
              onCancel={onClose}
              formContentClassName="p-6"
              formFooterClassName="p-6"
              workflowDefinition={workflowDefinition}
              currentStepId={currentStepId}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
